import script from "./ChevronLeftIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChevronLeftIcon.vue?vue&type=script&setup=true&lang=js"

import "./ChevronLeftIcon.vue?vue&type=style&index=0&id=db16843c&lang=scss"

export default script